<template>
  <div class="icon-button-row">
    <router-link v-for="(button, index) in filteredButtons" :key="index" :to="button.path" custom v-slot="{ navigate }">
      <button :class="{ 'is-active': isButtonActive(button) }" class="icon-button" @click="navigate">
        <div class="icon-text-container">
          <el-icon class="icon">
            <component :is="button.icon" />
          </el-icon>
          <span class="icon-text">{{ button.text }}</span>
        </div>
      </button>
    </router-link>
  </div>
</template>

<script setup>

import { ref, markRaw, getCurrentInstance, onMounted, computed } from 'vue';
import { ElIcon, ElMessage } from "element-plus";
import { useRouter, useRoute } from 'vue-router';
import { House, ShoppingCart, User, Menu } from "@element-plus/icons-vue";

const { proxy } = getCurrentInstance();
const router = useRouter();
const route = useRoute();
const isAdmin = ref('0');

const buttons = ref([
  { icon: markRaw(House), text: "首页", path: "/" },
  { icon: markRaw(Menu), text: "分类", path: "/houseCategory" },
  { icon: markRaw(ShoppingCart), text: "系统管理", path: "/manage" },
  { icon: markRaw(User), text: "我的", path: "/mySelf" },
]);

const filteredButtons = computed(() => {
  return buttons.value.filter(button => button.text !== '系统管理' || isAdmin.value === '1');
});

// 添加判断按钮是否激活的方法
const isButtonActive = (button) => {
  // 对于"系统管理"按钮，判断多个路径
  if (button.text === "系统管理") {
    return route.path === button.path || route.path === "/mobileSystemManage";
  }
  // 其他按钮使用原来的判断逻辑
  return route.path === button.path;
};

const checkRule = async () => {
  const url = '/login/checkRule';
  try {
    const response = await proxy.$tools.request(url, { reqBody: {} });
    if ('00000000' === response.data.rspHead.returnCode) {
      isAdmin.value = response.data.rspBody.isAdmin;
    } else {
      ElMessage.error('系统异常，请联系管理员');
    }
  } catch (error) {
    ElMessage.error('系统异常，请联系管理员', error);
  }
};

const checkLogin = () => {
  let token = localStorage.getItem("token");
  token = token || null;
  if (token) {
    const url = "/login/checkLoginStatus";
    proxy.$tools
      .request(url, { reqBody: {} })
      .then((response) => {
        const returnCode = response.data.rspHead.reurnCode;
        if (!"000000" === returnCode) {
          router.push("/error");
        }
        const status = response.data.rspBody.status;
        if ("0" === status) {
          router.push("/appLogin");
        }
      })
      .catch((error) => {
        console.error(error);
      });
  } else {
    router.push("/appLogin");
  }
};

onMounted(() => {
  checkLogin();
  checkRule();
});
</script>

<style scoped>
.icon-button-row {
  display: flex;
  justify-content: space-around;
  position: fixed;
  bottom: 0;
  left: 0;
  right: 0;
  width: 100%;
  height: 80px;
  /* padding: 12px 0; */
  background: rgba(255, 255, 255, 0.95);
  backdrop-filter: blur(10px);
  border-top: 1px solid rgba(224, 224, 224, 0.3);
  z-index: 1000;
  box-shadow: 0 -4px 12px rgba(0, 0, 0, 0.05);
}

.icon-button {
  flex: 1;
  max-width: 96px;
  /* padding: 8px; */
  border: none;
  background: transparent;
  transition: all 0.2s ease;
  position: relative;
}

.icon-text-container {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 4px;
}

.icon {
  width: 35px;
  height: 35px;
  font-size: 20px;
  color: #64748b;
  transition: all 0.2s ease;
}

.icon-text {
  font-size: 12px;
  color: #64748b;
  font-weight: 550;
  transition: all 0.2s ease;
}

/* 激活状态 */
.icon-button.is-active {
  .icon {
    color: black;
    filter: drop-shadow(0 2px 4px rgba(96, 165, 250, 0.2));
  }

  .icon-text {
    color: black;
    font-weight: 600;
  }

  /* &::after {
    content: '';
    position: absolute;
    top: -6px;
    left: 50%;
    transform: translateX(-50%);
    width: 24px;
    height: 3px;
    background: black;
    border-radius: 2px;
  } */
}

@media (max-width: 768px) {
  .icon-button-row {
    height: 60px;
  }

  /* .icon-button-row {
  padding: 6px 0;
} */
}

/* 响应式调整 */
@media (max-width: 480px) {
  .icon-button {
    padding: 6px;
  }

  .icon {
    width: 22px;
    height: 22px;
  }

  .icon-text {
    font-size: 11px;
  }
}

@media (max-width: 375px) {
  .icon-button {
    max-width: 72px;
  }

  .icon {
    width: 20px;
    height: 20px;
  }

  .icon-text {
    font-size: 10px;
  }
}
</style>